import { NgClass } from '@angular/common';
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { TranslateDirective } from '@ngx-translate/core';

import { FocusDirective } from '../../components/focus/focus.directive';
import { IconComponent } from '../../components/icon/icon.component';
import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
import { ButtonComponent } from '../../components/button/button.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { HelpArticleIndexComponent } from './help-article-index.component';
import { HelpMobileArticleComponent } from './help-mobile-article.component';
import { HelpScrollerDirective } from './help-scroller.directive';
import { HelpService } from './help.service';
import { Topic } from './help.domain';
import { HelpBaseComponent } from './help-base.component';

@Component({
  selector: 'td-wb-help-mobile',
  templateUrl: 'help-mobile.component.html',
  styleUrls: ['help-common.scss', 'help-mobile.component.scss'],
  imports: [
    ButtonComponent,
    TranslatePipe,
    IconComponent,
    NgClass,
    FocusDirective,
    HelpScrollerDirective,
    HelpArticleIndexComponent,
    HelpMobileArticleComponent,
    LoadingIndicatorComponent,
    TranslateDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpMobileComponent extends HelpBaseComponent implements OnInit, OnDestroy {
  showIndex: boolean = true;
  isIOS: boolean = false;
  opened: boolean = false;

  constructor(helpService: HelpService,
              platform: Platform,
              changeDetectorRef: ChangeDetectorRef) {
    super(helpService, changeDetectorRef);
    this.isIOS = platform.IOS;
  }

  ngOnInit(): void {
    this.showIndex = this.articleId === null;
    super.ngOnInit();
    this.opened = true;
  }

  close(): void {
    super.close();
    this.opened = false;
  }

  showContent(topic: Topic): false {
    this.showIndex = false;
    this.loadTopic(topic);
    return false;
  }

  closeContent(): false {
    this.showIndex = true;
    return false;
  }

  swipeLeft(): void {
    if (this.showIndex) {
      this.close();
    } else {
      this.closeContent();
    }
  }

  hasFocus(id: string): boolean {
    return id === this.articleId;
  }

  tabIndex(id: string): 0 | -1 {
    return id === this.articleId ? 0 : -1;
  }

  focusOn(indexId: string): void {
    this.articleId = undefined;
    this.helpService.scrollToLink(indexId);
  }
}
